/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_PasswordInputs */

const en_user_password = /** @type {(inputs: User_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const ja_user_password = /** @type {(inputs: User_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワード`)
};

const fr_user_password = /** @type {(inputs: User_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe`)
};

const de_user_password = /** @type {(inputs: User_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort`)
};

/**
* | output |
* | --- |
* | "Password" |
*
* @param {User_PasswordInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_password = /** @type {((inputs?: User_PasswordInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_PasswordInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_password(inputs)
	if (locale === "ja") return ja_user_password(inputs)
	if (locale === "fr") return fr_user_password(inputs)
	return de_user_password(inputs)
});